import isString from 'lodash/isString'
import styled, { css } from 'styled-components'

import type { MarginResponsive } from '@/theme/types'

import type { DefaultTheme } from 'styled-components'

export type DividerProps = {
  $bg: keyof DefaultTheme['colors']
  $width?: number | string
  $height?: number | string
  $opacity?: number
} & Partial<MarginResponsive>

export const Divider = styled.hr<DividerProps>`
  ${({ theme, $bg, $width, $height = 1, $opacity = 1, ...restProps }) => css`
    margin: 0;
    padding: 0;
    border: none;
    width: ${isString($width) ? $width : `${$width}px`};
    height: ${isString($height) ? $height : `${$height}px`};
    background-color: ${theme.colors[$bg]};
    opacity: ${$opacity};

    ${theme.helpers.getMarginStyles(restProps)}
  `}
`
